import React, { useState, useEffect } from "react";
import Select from "react-select";

import { getDeliver } from "../../../service/api/Deliver/apiDeliver";
import { getCompanies } from "../../../service/api/Company/apiCompany";

const SearchArea = ({
    searchForm,
    setSearchForm,
    onSearch,
    onReset,
    loading
}) => {
    const [drivers, setDrivers] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [statuses, setStatuses] = useState([
        { value: '', label: '全部' },
        { value: '0', label: '未完成' },
        { value: '1', label: '完成' },
    ]);

    useEffect(() => {
        // 從 API 獲取司機列表
        const fetchDrivers = async () => {
            try {
                const response = await getDeliver();
                if (response.status === 200 && response.data.status === 1) {
                    const driversList = response.data.result || [];
                    setDrivers(driversList);
                }
            } catch (error) {
                console.error('獲取司機列表失敗:', error);
            }
        };
        
        fetchDrivers();
    }, []);

    useEffect(() => {
        // 從 API 獲取公司列表
        const fetchCompanies = async () => {
            try {
                const response = await getCompanies();
                if (response.status === 200 && response.data.status === 1) {
                    const companiesList = response.data.result || [];
                    setCompanies(companiesList);
                }
            } catch (error) {
                console.error('獲取公司列表失敗:', error);
            }
        };
        
        fetchCompanies();
    }, []);

    return (
        <div className="card-body">
            {/* 第一行 - 派車編號、派車名稱、車牌 */}
            <div className="search-section">
                <div className="row g-4">
                    <div className="col-lg-4 col-md-6">
                        <div className="form-group-premium">
                            <input
                                id="deliverId"
                                name="deliverId"
                                type="text"
                                className="form-control-premium"
                                value={searchForm.id || ''}
                                onChange={(e) => setSearchForm(prev => ({ ...prev, id: e.target.value }))}
                                placeholder="派車編號"
                            />
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="form-group-premium">
                            <input
                                id="plate"
                                name="plate"
                                type="text"
                                className="form-control-premium"
                                value={searchForm.plate || ''}
                                onChange={(e) => setSearchForm(prev => ({ ...prev, plate: e.target.value }))}
                                placeholder="車牌"
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* 第二行 - 司機名稱、公司名稱、派車狀態 */}
            <div className="search-section">
                <div className="row g-4">
                    <div className="col-lg-4 col-md-6">
                        <div className="form-group-premium">
                            <Select
                                inputId="deliverName"
                                name="deliverName"
                                options={drivers.map(driver => ({ value: driver.name, label: driver.name }))}
                                value={searchForm.name ? { value: searchForm.name, label: searchForm.name } : null}
                                onChange={(option) => setSearchForm(prev => ({ ...prev, name: option?.value || '' }))}
                                isClearable
                                isSearchable
                                placeholder="-- 選擇司機 --"
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        borderColor: '#dadce0',
                                        borderRadius: '8px',
                                        padding: '2px 8px',
                                        minHeight: '40px',
                                        fontSize: '14px'
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isSelected ? '#1f73e6' : state.isFocused ? '#f0f2f5' : 'white',
                                        color: state.isSelected ? 'white' : '#202124'
                                    })
                                }}
                            />
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="form-group-premium">
                            <Select
                                inputId="companyName"
                                name="companyName"
                                options={companies.map(company => ({ value: company.id, label: company.name }))}
                                value={searchForm.company_id ? { value: searchForm.company_id, label: companies.find(company => company.id === searchForm.company_id)?.name || '' } : null}
                                onChange={(option) => {setSearchForm(prev => ({ ...prev, company_id: option?.value || '' }))}}
                                isClearable
                                isSearchable
                                placeholder="-- 選擇公司 --"
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        borderColor: '#dadce0',
                                        borderRadius: '8px',
                                        padding: '2px 8px',
                                        minHeight: '40px',
                                        fontSize: '14px'
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isSelected ? '#1f73e6' : state.isFocused ? '#f0f2f5' : 'white',
                                        color: state.isSelected ? 'white' : '#202124'
                                    })
                                }}
                            />
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="form-group-premium">
                            <Select
                                inputId="status"
                                name="status"
                                options={statuses}
                                value={statuses.find(s => s.value === (searchForm.status || ''))}
                                onChange={(option) => setSearchForm(prev => ({ ...prev, status: option?.value || '' }))}
                                isClearable={false}
                                isSearchable
                                placeholder="-- 選擇狀態 --"
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        borderColor: '#dadce0',
                                        borderRadius: '8px',
                                        padding: '2px 8px',
                                        minHeight: '40px',
                                        fontSize: '14px'
                                    }),
                                    option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isSelected ? '#1f73e6' : state.isFocused ? '#f0f2f5' : 'white',
                                        color: state.isSelected ? 'white' : '#202124'
                                    })
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* 第三行 - 派車開始時間、派車結束時間、還車時間 */}
            <div className="search-section">
                <div className="row g-4">
                    {/* 派車開始時間範圍 */}
                    {/* 還車時間 */}
                    <div className="col-lg-4">
                        <div className="form-group-premium">
                            <label className="form-label" style={{ fontSize: '0.75rem', color: '#999' }}>派車開始時間</label>
                            <input
                                id="usedAt"
                                name="usedAt"
                                type="date"
                                className="form-control-premium"
                                value={searchForm.used_at || ''}
                                onChange={(e) => setSearchForm(prev => ({ ...prev, used_at: e.target.value }))}
                                placeholder="派車開始時間"
                            />
                        </div>
                    </div>

                    {/* 還車時間 */}
                    <div className="col-lg-4">
                        <div className="form-group-premium">
                            <label className="form-label" style={{ fontSize: '0.75rem', color: '#999' }}>還車時間</label>
                            <input
                                id="returnAt"
                                name="returnAt"
                                type="date"
                                className="form-control-premium"
                                value={searchForm.return_at || ''}
                                onChange={(e) => setSearchForm(prev => ({ ...prev, return_at: e.target.value }))}
                                placeholder="還車時間"
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* 動作按鈕 - 搜尋 & 重置 */}
            <div className="search-action-group">
                <button
                    className="btn btn-primary fw-bold"
                    onClick={onSearch}
                    disabled={loading}
                >
                    <i className="fas fa-search me-2"></i>{loading ? '搜尋中...' : '搜尋'}
                </button>
                <button
                    className="btn btn-secondary fw-bold"
                    onClick={onReset}
                >
                    <i className="fas fa-redo me-2"></i>重置
                </button>
            </div>
        </div>
    );
};

export { SearchArea };
